import { render } from "./OidoCardContent.vue?vue&type=template&id=236da321&scoped=true"
import script from "./OidoCardContent.vue?vue&type=script&lang=js"
export * from "./OidoCardContent.vue?vue&type=script&lang=js"

import "./OidoCardContent.vue?vue&type=style&index=0&id=236da321&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236da321"]])

export default __exports__